<rs-general-dialog
  [visible]="visible"
  (visibleChange)="handleClose()"
  [dialogTitle]="defaultTitle"
  i18n-confirmText
  confirmText="Ok"
  [contentClass]="'rs-http-error-dialog'"
  [dialogStyle]="dialogStyle"
  (confirmAction)="handleClose()"
  (exitAction)="handleClose()"
>
  <rs-icon headerIcon [icon]="ICONS.warningTriangle"></rs-icon>
  <div class="http-error-body">
    <p class="http-error-problem-detail">{{ message }}</p>
  </div>
</rs-general-dialog>
